import { supabase } from '../supabaseClient';

async function getAllEventTokens(eventId) {
    let query = supabase.from('EventTokens').select('*,tokenId(*),prerequisiteId(*,tokenId(*)),EventTokensLaunchRelations!left(*,launchId(*))', { count: 'exact' }).eq('eventId', eventId)
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}

async function updateEventTokens(obj) {
    console.log(obj)
    obj.last_updated_at = Date.now()
    let query = supabase.from('EventTokens').update(obj).eq('eventTokenId', obj.eventTokenId)
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}

async function insertEventTokens(obj) {
    let query = supabase.from('EventTokens').insert(obj)
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}

async function deleteEventTokens(eventTokenId) {
    let query = supabase.from('EventTokens').delete().eq('eventTokenId', eventTokenId)
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}

async function getAllEventTokenAlgos() {
    let query = supabase.from('EventTokenAlgorithms').select('*', { count: 'exact' })
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}

async function insertTagLaunches(obj) {
    let query = supabase.from('EventTokensLaunchRelations').insert(obj)
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}

async function editTagLaunches(obj) {
    let query = supabase.from('EventTokensLaunchRelations').update({launchId:obj?.launchId}).eq("eventId",obj?.eventId).eq("eventTokenId",obj?.eventTokenId)
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}

async function deleteTagLaunches(eventId) {
    let query = supabase.from('EventTokensLaunchRelations').delete().eq("eventId",eventId)
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}

async function checkTagLaunchesData(eventId,eventTokenId) {
    let query = supabase.from('EventTokensLaunchRelations').select('*,launchId(*)', { count: 'exact' }).eq("eventId",eventId).eq("eventTokenId",eventTokenId)
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}

async function checkTagLaunchesByLaunchId(eventId,launchIds) {
    let query = supabase.from('EventTokensLaunchRelations').select('*,launchId(*)', { count: 'exact' }).eq("eventId",eventId).in("launchId",launchIds)
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}

async function getLaunchSalesRelationsById(userId) {
    let query = supabase
      .from("LaunchSalesRelations")
      .select("*")
      .eq("userId", userId)
    const { data, count, error } = await query;
    if (data) return { data, count };
    else throw error;
}

export { getAllEventTokens, updateEventTokens, getAllEventTokenAlgos, insertEventTokens, deleteEventTokens,insertTagLaunches,checkTagLaunchesData,editTagLaunches,deleteTagLaunches,getLaunchSalesRelationsById,checkTagLaunchesByLaunchId }